var ParticleData = /** @class */ (function () {
    function ParticleData() {
    }
    return ParticleData;
}());
export { ParticleData };
